import { Component } from "react";
import HttpErrorContent from "@/views/errors/HttpErrorContent";

export default class SiteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error("[SiteErrorBoundary]", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ error: null, errorInfo: null });
    window.location.assign("/");
  };

  render() {
    const { error, errorInfo } = this.state;
    if (error) {
      return (
        <HttpErrorContent
          code={500}
          titleOverride="This page crashed"
          descriptionOverride="Something went wrong while displaying this page. You can return to the home page and try again."
          debugPayload={{
            message: error?.message || String(error),
            stack: error?.stack,
            componentStack: errorInfo?.componentStack,
          }}
          onPrimaryAction={this.handleReset}
          primaryActionLabel="Return to home"
        />
      );
    }
    return this.props.children;
  }
}
